import React, { useState } from 'react';
import type { CSSProperties, InputHTMLAttributes } from 'react';
import { cn } from '@/utils/utils';
import { Search } from 'lucide-react';

interface SearchBarProps 
  extends InputHTMLAttributes<HTMLInputElement> {
    className?: string;
    style?: CSSProperties;
    setSearch: (query: string) => void;
  }


const SearchBar = React.forwardRef<HTMLInputElement, SearchBarProps>(({ className, style, setSearch, ...props }, ref) => {
  const [query, setQuery] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setQuery(value);
    setSearch(value);
  };

  return (
    <div className={cn("relative w-full", className)}>
      <input
        type="search"
        className="w-full pr-10 pl-3 py-2 h-15 border border-gray-300 focus:outline-none focus:ring-1"
        style={style}
        value={query}
        placeholder="Search"
        ref={ref}
        onChange={handleChange}
        {...props}
      />
      <Search className="absolute right-3 top-1/2 -translate-y-1/2 h-6 w-6 text-gray-400 pointer-events-none" />
    </div>
  );
});
SearchBar.displayName = "SearchBar";

export default SearchBar;
